document.addEventListener("DOMContentLoaded", function (event) {
  // Navigation
  let allMegaMenuItems = document.querySelectorAll(".mega-menu .item");
  allMegaMenuItems.forEach((item) => {
    if (item.querySelector(".mega-menu-content")) {
      item.addEventListener("mouseover", () => {
        item.querySelector(".mega-menu-content").classList.add("active");
      });
      item.addEventListener("mouseleave", () => {
        item.querySelector(".mega-menu-content").classList.remove("active");
      });
    }
  });

  // Animation/Toggle for the navigation toggler
  if (document.getElementById("sidenav_toggler_btn")) {
    let btn = document.getElementById("sidenav_toggler_btn");
    let btnOpenSidenav = document.getElementById("sidenav_toggler_btn_open");
    let sidenavbtn = document.getElementById("sidenav_toggler");
    let sidenavOpen = document.getElementById("sidenav_toggler_open");
    btnOpenSidenav.addEventListener("click", function () {
      document.getElementById("sidebar-fixed").classList.toggle("show");
      sidenavbtn.classList.toggle("open");
      sidenavOpen.classList.toggle("open");
    });
    btn.addEventListener("click", function () {
      document.getElementById("sidebar-fixed").classList.toggle("show");
      sidenavbtn.classList.toggle("open");
      sidenavOpen.classList.toggle("open");
    });
  }
  if (document.getElementById("more_toggler_btn")) {
    document
      .getElementById("more_toggler_btn")
      .addEventListener("click", function () {
        document.getElementById("morebar").classList.toggle("show");
      });
  }

  // Search Page dropdown toggle
  if (document.querySelector(".search-filter-item__checkbox")) {
    let allDropdownItems = document.querySelectorAll(
      ".search-filter-item__checkbox"
    );
    allDropdownItems.forEach((item) => {
      if (item.querySelector("figure>img")) {
        item.querySelector("figure>img").addEventListener("click", () => {
          item.querySelectorAll(".search-filter-subitem").forEach((subItem) => {
            subItem.classList.toggle("hide");
          });
        });
      }
    });
  }

  // Tab
  if (document.querySelector(".tab-one")) {
    let tabOne = Tabs({
      el: ".tab-one",
      tabNavigationLinks: ".tab-link",
      tabContentContainers: ".tab-content",
    });
    tabOne.init();
  }

  // product gallery slider
  if (document.querySelector(".gallery-slider")) {
    var catThumbsContainer = document.querySelector(".cat-thumbs");
    var catThumbs = catThumbsContainer.querySelectorAll("button");

    let gallerySlider = new Siema({
      selector: ".gallery-slider",
      duration: 500,
      perPage: 1,
      draggable: true,
      easing: "cubic-bezier(.17,.67,.32,1.34)",
      loop: false,
      onInit: slideIndex,
      onChange: slideIndex,
    });

    function slideIndex() {
      for (let i = 0; i < catThumbs.length; i++) {
        if (catThumbs[i].classList.contains("active")) {
          catThumbs[i].classList.remove("active");
        }

        catThumbs[this.currentSlide].classList.add("active");

        catThumbs[i].addEventListener("click", (e) => {
          gallerySlider.goTo(i);
          catThumbs[i].classList.add("active");
        });
      }
    }
    let sliderClass = document.querySelector(".product-slider-container");
    sliderClass
      .querySelector(".prevImg")
      .addEventListener("click", () => gallerySlider.prev());
    sliderClass
      .querySelector(".nextImg")
      .addEventListener("click", () => gallerySlider.next());
  }

  // home header slider
  if (document.querySelector(".banner-slider")) {
    let bannerSlider = new Siema({
      selector: ".banner-slider",
      duration: 500,
      perPage: 1,
      draggable: true,
      easing: "cubic-bezier(.17,.67,.32,1.34)",
      loop: true,
    });
    let sliderClass = document.querySelector(".banner-slider-container");
    sliderClass
      .querySelector(".prevImg")
      .addEventListener("click", () => bannerSlider.prev());
    sliderClass
      .querySelector(".nextImg")
      .addEventListener("click", () => bannerSlider.next());
  }

  // product related slider
  if (document.querySelector(".seller-related-product-slider")) {
    let relatedSlider = new Siema({
      selector: ".seller-related-product-slider",
      duration: 500,
      perPage: 1,
      draggable: true,
      easing: "cubic-bezier(.17,.67,.32,1.34)",
      loop: true,
    });
    let sliderClass = document.querySelector(
      ".seller-related-product-slider-container"
    );
    sliderClass
      .querySelector(".prevImg")
      .addEventListener("click", () => relatedSlider.prev());
    sliderClass
      .querySelector(".nextImg")
      .addEventListener("click", () => relatedSlider.next());
  }
});
